import React from 'react';

const RegisterLoading = () => {
  return (
    <div className="register-loading">
      <div className="register-spinner">
        <div className="ring"></div>
      </div>
      <p>Creating account...</p>
      
      <style jsx>{`
        .register-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          color: white;
          text-align: center;
        }
        
        .register-spinner {
          width: 40px;
          height: 40px;
          margin-bottom: 16px;
          position: relative;
        }
        
        .ring {
          width: 100%;
          height: 100%;
          border: 3px solid rgba(231, 76, 60, 0.2);
          border-left-color: #e74c3c;
          border-radius: 50%;
          animation: rotate 1s linear infinite;
        }
        
        p {
          margin: 0;
          font-size: 14px;
          color: #8892b0;
          font-weight: 500;
        }
        
        @keyframes rotate {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default RegisterLoading;